<template>
    <div class="vh-flex" v-loading="showLoading">
        <!--筛选工具栏-->
        <div class="filttoolbar">
            <!--left-->
            <div class="vc-flex">
                <div @click="changeFiltter(item)" v-for="item in listFiltters" :key="item.key" class="filtitem focus-s"
                    :class="{ 'selfilter': item.key == filtterKey }">
                    {{ item.name }}
                </div>
            </div>
            <!--right-->
            <div class="vc-flex">
                <IconMenu @click="openImportDialog" svgname="ic_import2" textSize="14px" :iconSize="16" space="5px"
                    name="导入">
                </IconMenu>
            </div>
        </div>
        <div v-if="initOver==false">

        </div>
        <EmptyView v-else-if="listSentence.length == 0" @mainClick="openImportDialog" mainButton="导入句子"></EmptyView>
        <div v-else class="vh-full vh-flex">
            <el-scrollbar class="vh-full">
                <div class="inrect">
                    <div v-for="item in listSentence" :key="item.sentenceId" class="sentenceitem">
                        <div class="lbsentence">{{ item.sentence }}</div>
                        <div class="symbol">{{ symbolWrapper(item.symbol) }}</div>
                        <div class="lbtranslate">{{ item.translate }}</div>
                        <!--底部数据栏-->
                        <div class="divdata mgt10">
                            <div class="vc-flex">
                                <div title="拼写次数" class="lbspcount">{{ item.spellCount }}</div>
                                <div title="评分" class="lbscore" :class="{'lowscore':item.scoreValue<0,'highscore':item.scoreValue>0}">{{ item.scoreValue }}</div>
                                <div @click="playSound(item)" class="lbspcount focus-s">
                                    <SvgIcon svgname="ic_media_sound" fill="var(--ek-text-color2)" :size="10"></SvgIcon>
                                </div>
                                <div @click="changeCollect(item)" class="lbspcount focus-s">
                                    <SvgIcon svgname="ic_collect" :fill="item.collected?'#F79900':'var(--ek-text-color2)'" :size="10"></SvgIcon>
                                </div>
                                <div title="标记掌握" @click="changeMaster(item)" class="lbspcount focus-s">
                                    <SvgIcon svgname="ic_master" :fill="item.learnStatus==2?'#E545C1':'var(--ek-text-color2)'" :size="10"></SvgIcon>
                                </div>
                            </div>
                            <div class="vc-flex itemright">
                                <IconView @click="openEditDialog(item)" svgname="ic_edit1" :iconSize="12"></IconView>
                                <IconView @click="deleteSentence(item)" class="mgl10" svgname="ic_delete"
                                    :iconSize="14">
                                </IconView>
                            </div>
                        </div>
                    </div>
                </div>
            </el-scrollbar>
            <div class="vpage">
                <el-pagination layout="prev, pager, next,total,jumper" :total="page.totalCount" :page-size="page.size"
                    @current-change="onPageChange" />
            </div>
        </div>
        <!--添加词汇对话框-->
        <ImportSentenceDialog :show="addDialog.show" :bookId="bookInfo.bookId"
            :unitId="selectUnit != null ? selectUnit.unitId : ''" @selectButton="addDialog.callBack">
        </ImportSentenceDialog>
        <!--编辑词汇对话框-->
        <EditSentenceDialog :show="editDialog.show" :sentenceItem="editDialog.sentenceItem"
            @selectButton="editDialog.callBack">
        </EditSentenceDialog>
        <!--确认对话框-->
        <ConfirmDialog :showDialog="confirmDialog.show" :title="confirmDialog.title" :message="confirmDialog.message"
            @selectButton="confirmDialog.callBack">
        </ConfirmDialog>
    </div>
</template>

<script>
import EmptyView from '@/components/EmptyView.vue';
import ImportSentenceDialog from '../../dialog/ImportSentenceDialog.vue';
import httpClient from '@/commom/http/httpClient';
import stringHelper from '@/commom/string/StringHelper.js';
import IconMenu from '@/components/IconMenu.vue';
import IconView from '@/components/IconView.vue';
import EditSentenceDialog from '../../dialog/EditSentenceDialog.vue';
import ConfirmDialog from '@/components/dialog/ConfirmDialog.vue';
import SvgIcon from '@/components/SvgIcon.vue';
import textSoundPlayer from '@/commom/media/TextSoundPlayer.js';

export default {
    name: 'SentenceManager',
    components: {
        EmptyView,
        ImportSentenceDialog,
        IconMenu,
        IconView,
        EditSentenceDialog,
        ConfirmDialog,
        SvgIcon
    },
    props: {
        bookInfo: Object,
        selectUnit: Object
    },
    watch: {
        selectUnit: function (nval, old) {
            this.loadFirstPage()
        }
    },
    data() {
        return {
            initOver:false,
            showLoading: false,
            filtterKey: "all",
            keyword: "",
            sortType: "default",
            listFiltters: [
                { name: "全部", key: "all" },
                { name: "未开始", key: "new" },
                { name: "已学习", key: "learn" },
                { name: "已掌握", key: "master" },
                { name: "已收藏", key: "collect" },
            ],
            addDialog: {
                show: false,
                callBack: null
            },
            editDialog: {
                show: false,
                sentenceItem: null,
                callBack: null
            },
            confirmDialog: {
                show: false,
                title: "删除",
                message: "",
                callBack: null
            },
            page: {
                index: 1,
                size: 30,
                totalCount: 0,
            },
            listSentence: [],

        }
    },
    mounted: function () {
        if (this.selectUnit != null) {
            this.loadFirstPage()
        }
    },
    methods: {
        ///加载数据
        loadData: function () {
            if (this.selectUnit == null) {
                return;
            }
            var req = {
                page: this.page.index,
                size: this.page.size,
                bookId: this.bookInfo.bookId,
                unitId: this.selectUnit.unitId,
                filtterKey: this.filtterKey,
                keyword: this.keyword,
                sortType: this.sortType,
            }
            var that = this
            this.showLoading = true
            httpClient.invoke("UnitSentenceAPI.GetListPage", req, function (res) {
                console.log("返回结果", res)
                that.showLoading = false
                if(that.initOver==false){
                    that.initOver = true
                }
                if (res.error) {
                    that.$message.error(res.error.message)
                    return
                }
                if (req.page == 1) {
                    that.page.totalCount = res.totalCount
                }
                that.listSentence = res.listItem
            })

        },
        ///加载第一页
        loadFirstPage: function () {
            this.page.index = 1;
            this.loadData();
        },
        ///页码改变
        onPageChange: function (index) {
            this.page.index = index;
            this.loadData();
        },
        ///改变过滤
        changeFiltter: function (item) {
            this.filtterKey = item.key
            this.loadFirstPage()
        },
        symbolWrapper: function (symbol) {
            return stringHelper.symbolWrapper(symbol)
        },
        ///打开导入对话框
        openImportDialog: function () {
            this.addDialog.show = true
            var that = this
            this.addDialog.callBack = function (res) {
                that.addDialog.show = false
                if (res.confrim) {
                    that.filtterKey = "all"
                    that.loadFirstPage()
                }
            }
        },
        ///编辑词汇
        openEditDialog: function (sentenceItem) {
            this.editDialog.show = true
            this.editDialog.sentenceItem = sentenceItem
            var that = this
            this.editDialog.callBack = function (res) {
                that.editDialog.show = false
                if (res.confrim) {
                    that.loadData()
                }
            }
        },
        ///删除句子
        deleteSentence: function (sentenceItem) {
            this.confirmDialog.show = true
            this.confirmDialog.message = "确定删除此句子吗？"
            var that = this
            this.confirmDialog.callBack = function (ok) {
                that.confirmDialog.show = false
                if (!ok) {
                    return
                }
                var req = {
                    sentenceId: sentenceItem.sentenceId
                }
                httpClient.invoke("UnitSentenceAPI.DeleteSentence", req, function (res) {
                    if (res.error) {
                        that.$message({ message: res.error })
                        return
                    }
                    if (!res.success) {
                        that.$message({ message: res.message })
                        return
                    }
                    //移除sentenceItem
                    var index = that.listSentence.indexOf(sentenceItem)
                    if (index != -1) {
                        that.listSentence.splice(index, 1)
                    }
                    //that.loadData()
                })
            }
        },
        ///播放句子发音
        playSound: function (sentenceItem) {
            textSoundPlayer.playText(sentenceItem.sentence)
        },
        ///改变收藏
        changeCollect:function(item){
            var tarValue = !item.collected
            var req = {
                sentenceId: item.sentenceId,
                collected: tarValue
            }
            var that = this
            httpClient.invoke("UnitSentenceAPI.UpdateCollected", req, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                if (!res.success) {
                    that.$message({ message: res.message })
                    return
                }
                //更新item
                item.collected = tarValue
            })

        },
        ///改变已掌握
        changeMaster:function(item){
            var tarValue = item.LearnStatus==2?0:2
            var req = {
                sentenceId: item.sentenceId,
                learnStatus: tarValue
            }
            var that = this
            httpClient.invoke("UnitSentenceAPI.UpdateLearnStatus", req, function (res) {
                if (res.error) {
                    that.$message.error(res.error)
                    return
                }
                if (!res.success) {
                    that.$message({ message: res.message })
                    return
                }
                //更新item
                item.LearnStatus = tarValue
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sentenceitem .itemright {
    opacity: 0;
    transition: opacity 0.2s ease;
}

.sentenceitem:hover .itemright {
    opacity: 1;
}

.lbspcount {
    background: var(--ek-card-color2);
    font-size: 13px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
    line-height: 20px;
    color: var(--ek-text-color2);
    margin-right: 10px;
}

.lbscore {
    background: var(--ek-card-color2);
    font-size: 12px;
    padding-left: 10px;
    padding-right: 10px;
    border-radius: 10px;
    line-height: 20px;
    color: var(--ek-text-color2);
    margin-right: 10px;
}
.lowscore{
    background: #ff000038!important;
    color: #ff3939!important;
}
.highscore{
    background: #00ff182e!important;
    color: #3ec620!important;
}

.divdata {
    display: flex;
    justify-content: space-between;
}

.lbtranslate {
    color: var(--ek-text-color2);
    font-size: 14px;
    margin-top: 5px;
    margin-bottom: 5px;
}

.lbsentence {
    color: var(--ek-text-color1);
    font-size: 16px;
    
}

.symbol {
    font-size: 14px;
    color: var(--ek-text-color2);
    margin-top: 5px;
    margin-bottom: 5px;
}

.sentenceitem {
    margin-left: 25px;
    margin-right: 25px;
    padding-top: 10px;
    padding-bottom: 10px;
    border-bottom: 2px dashed var(--ek-split-lineColor);
}

.filttoolbar {
    display: flex;
    justify-content: space-between;
    margin-left: 20px;
    margin-right: 20px;
    padding-top: 10px;
    padding-bottom: 10px;
}

.filtitem {
    color: var(--ek-text-color2);
    padding-left: 15px;
    padding-right: 15px;
    padding-top: 5px;
    padding-bottom: 5px;
    border-radius: 5px;
    font-size: 14px;
}

.selfilter {
    color: var(--ek-text-color1);
    background-color: var(--ek-card-color2);
}

.vpage {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
    padding-top: 15px;
}
</style>
